import { StyleSheet as PDFStyleSheet } from '@react-pdf/renderer'

const styles = PDFStyleSheet.create({
  mainDiv: {
    width: '100%',
    paddingLeft: '5%',
    paddingRight: '5%',
    borderRightWidth: 1,
    borderBottomWidth: 1,
    borderStyle: 'dashed',
    borderColor: '#dbdbdb'
  },
  content: {
    width: '100%',
    flexDirection: 'row-reverse',
    marginVertical: 8
  },
  sunjectTitle: {
    fontSize: 9,
    color: 'grey',
    marginLeft: 4
  },
  subjectValue: {
    fontSize: 9,
    color: 'black'
  },
  subject1: {
    width: '70%',
    alignItems: 'flex-end'
  },
  subject2: {
    width: '30%',
    alignItems: 'flex-end'
  },
  rowDirection: {
    flexDirection: 'row-reverse',
    alignItems: 'center',
    marginVertical: 2
  }
})
export default styles
